import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronLeft, faCheckCircle} from "@fortawesome/free-solid-svg-icons";
import {Link, useNavigate} from "react-router-dom";
import {useEffect, useState} from "react";

function VerifyCodeSuccess() {
    const [countDown, setCountDown] = useState(5);
    const navigate = useNavigate();

    useEffect(() => {
        if (countDown <= 0){
            navigate("/auth/signin", { replace: true });
            return;
        }

        const timer = setInterval(() => {
            setCountDown(prev => prev - 1);
        }, 1000);

        return () => clearInterval(timer);
    }, [countDown]);
    return (
        <main className='main'>
            <div className='container'>
                <div className='row flex-center auth-wrapper py-5'>
                    <div className='col-sm-10 col-md-8 col-lg-5 col-xl-5 col-xxl-3'>
                        <div className="px-xxl-5">
                            <div className="text-center mb-6">
                                <div className="mb-3">
                                    <div className="d-flex flex-column align-items-center mb-3">
                                        <FontAwesomeIcon className="text-success fw-bold fs-4" icon={faCheckCircle} />
                                        <span className="fs-7 fw-bold mt-2">Success</span>
                                    </div>
                                    <h4 className="mb-3 text-success">Email Verified</h4>
                                    <p className="text-body-tertiary fs-8-1 mb-1">Your email address was successfully verify.</p>
                                </div>
                                <p className="fs-8-1 text-body-tertiary">
                                    You will be redirected to the login page in <span id="countdown">{countDown}</span> seconds.<br/>
                                    If not, please click “Go to Signin”.
                                </p>
                                <p>
                                    <Link className="w-100 mb-3 fs-9 fw-bold " to="/auth/signin">
                                        <FontAwesomeIcon className="me-2" icon={faChevronLeft}/>Go to Signin page
                                    </Link>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <footer className='text-center'>
                <span className="fs-9 pe-3">©2025 BreakThrough, Inc. All rights reserved.</span>
                <Link className="fs-9 fw-semibold pe-3" to="/home">Terms of use</Link>
                <Link className="fs-9 fw-semibold" to="/home">Privacy policy</Link>
            </footer>
        </main>
    )
}
export default VerifyCodeSuccess;